/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "appointmentsapi",
            "endpoint": "https://8sb8andi0a.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "carenotesapi",
            "endpoint": "https://y4rm1u48fb.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "careprovidersapi",
            "endpoint": "https://9okrq8cd62.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "factssheetapi",
            "endpoint": "https://xtu6ndtitg.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hifoodjournalapi",
            "endpoint": "https://9k4bfg0uc2.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrallergiesapi",
            "endpoint": "https://av65wp3ga3.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrapilabsimaging",
            "endpoint": "https://63wn3wf57c.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrcarenotesapi",
            "endpoint": "https://vvr547idh3.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrlifestyleapi",
            "endpoint": "https://08kqopx5id.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrmedicalconditionapi",
            "endpoint": "https://bhtw07h2t5.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrmentalhealthapi",
            "endpoint": "https://onyb5oy290.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "hrsymptomsapi",
            "endpoint": "https://yp7sc9qnr7.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "pcmedapi",
            "endpoint": "https://5w7j25u8ta.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        },
        {
            "name": "todosapi",
            "endpoint": "https://5vodjt8njg.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:b40c6e0a-b19f-44ef-bf52-79ca88ba2bee",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_NerXWN9ak",
    "aws_user_pools_web_client_id": "61dca2i3tv62vvnn35fnvfjfah",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "BIRTHDATE",
        "GIVEN_NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "pc-medfolio-poc-storage-4bf7a2cf5f957-main",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
